import { TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import useLang from "../../../../Shared/hooks/useLanguage";
import { CrossIcon, DoneIcon } from "../../../../Shared/Icons";
// import { TestSetupSaveData } from "Services/NGSRunCreation";
import { validateFields } from "Pages/LIS/Toxicology/CommonFunctions";
import { SaveRunCreation } from "Services/NGSRunCreation";
import PermissionComponent, {
  getPermissionDisplayName,
} from "Shared/Common/Permissions/PermissionComponent";

function Row({
  row,
  rows,
  index,
  setRows,
  selectedBox,
  loadGridData,
  setSelectedBox,
  queryDisplayTagNames,
}: any) {
  const { t } = useLang();

  const [disableSaveBbutton, setDisableSaveBbutton] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState({
    dropdown1: null,
    dropdown2: null,
    dropdown3: null,
    dropdown4: null,
  });

  const handleClose = (dropdownName: string) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: null });
  };

  const getValues = (r: any) => {
    const updatedRows = rows.map((row: any) => {
      if (row.id === r.id) {
        return { ...row, rowStatus: true };
      }
      return row;
    });
    setRows(updatedRows);
  };

  const handleChange = (name: string, value: string, id: number) => {
    setRows((curr: any) =>
      curr.map((x: any) => (x.id === id ? { ...x, [name]: value } : x))
    );
  };

  const handleSave = async () => {
    const { isValid, invalidField } = validateFields({
      runName: row.runName,
    });

    if (!isValid) {
      const errorMessage = invalidField
        ? `Please Fill ${queryDisplayTagNames[invalidField] ?? ""} field`
        : "Invalid field found";

      toast.error(errorMessage);
      return;
    }

    const payload = {
      id: row.id,
      runName: row.runName,
      runDate: row.id === 0 ? new Date().toISOString() : row.runDate,
      runId: row.runId,
      projectId: row.projectId,
      notes: row.notes,
    };

    try {
      setDisableSaveBbutton(true);

      const res = await SaveRunCreation(payload);

      if (res?.data?.statusCode === 200) {
        loadGridData();
        handleClose("dropdown2");
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error saving run creation:", error);
      toast.error("An unexpected error occurred.");
    } finally {
      setDisableSaveBbutton(false);
    }
  };

  const handleChangeSelectedIds = (checked: boolean, id: number): void => {
    setSelectedBox((prev: typeof selectedBox) => ({
      ...prev,
      ids: checked
        ? prev.ids.includes(id)
          ? prev.ids
          : [...prev.ids, id]
        : prev.ids.filter((item: number) => item !== id),
    }));
  };

  return (
    <>
      <TableRow className="h-30px">
        <TableCell>
          <label className="form-check form-check-sm form-check-solid d-flex justify-content-center">
            <input
              id={`ManageOrderNewOrderCheckBox_${row.id}`}
              className="form-check-input"
              type="checkbox"
              checked={selectedBox?.ids?.includes(row?.id)}
              onChange={(e) =>
                handleChangeSelectedIds(e.target.checked, row.id)
              }
            />
          </label>
        </TableCell>
        <TableCell>
          <div className="d-flex justify-content-center">
            {row?.rowStatus ? (
              <div className="gap-2 d-flex">
                <button
                  disabled={disableSaveBbutton}
                  id={`NGSRunCreationSave`}
                  onClick={handleSave}
                  className="btn btn-icon btn-sm fw-bold btn-table-save btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <DoneIcon />
                </button>
                <button
                  id={`NGSRunCreationCancel`}
                  onClick={() => {
                    loadGridData();
                    handleClose("dropdown2");
                    if (row?.id !== 0) {
                      const updatedRows = rows.map((r: any) => {
                        if (r.id === row?.id) {
                          return { ...r, rowStatus: false };
                        }
                        return r;
                      });
                      setRows(updatedRows);
                    } else {
                      const newArray = [...rows];
                      newArray.splice(index, 1);
                      setRows(newArray);
                    }
                  }}
                  className="btn btn-icon btn-sm fw-bold btn-table-cancel btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <CrossIcon />
                </button>
              </div>
            ) : (
              <div className="rotatebtnn">
                <DropdownButton
                  className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
                  key="end"
                  id={`NGSRunCreation3Dots_${row.id}`}
                  drop="end"
                  title={<i className="bi bi-three-dots-vertical p-0"></i>}
                >
                  <PermissionComponent
                    moduleName="NGS LIS"
                    pageName="View Run"
                    permissionIdentifier="Edit"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id={`NGSRunCreationEdit`}
                        className="w-auto"
                        eventKey="1"
                        onClick={() => {
                          getValues(row);
                        }}
                      >
                        <i className="fa-solid fa-edit text-primary mr-2"></i>
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Edit"
                        )}
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                </DropdownButton>
              </div>
            )}
          </div>
        </TableCell>
        <TableCell
          id={`NGSRunCreationRunName_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.runName}
        </TableCell>
        <TableCell
          id={`NGSRunCreationRunStatus_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.runStatus}
        </TableCell>
        <TableCell
          id={`NGSRunCreationorderCode_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {moment(row?.runDate)?.format("MM/DD/YYYY")}
        </TableCell>
        <TableCell
          id={`NGSRunCreationRunId_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="d-flex">
              <input
                id={`NGSRunCreationRunId`}
                type="text"
                placeholder={t("Created By")}
                name="runId"
                className="form-control mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.runId || ""}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.id)
                }
              />
            </div>
          ) : (
            row?.runId
          )}
        </TableCell>
        <TableCell
          id={`NGSRunCreationProjectId_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="d-flex">
              <input
                id={`NGSRunCreationProjectId`}
                type="text"
                placeholder={t("Created By")}
                name="projectId"
                className="form-control mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.projectId || ""}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.id)
                }
              />
            </div>
          ) : (
            row?.projectId
          )}
        </TableCell>
        <TableCell
          id={`NGSRunCreationDownloadStartTime_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.downloadStartTime}
        </TableCell>
        <TableCell
          id={`NGSRunCreationDownloadEndTime_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.downloadEndTime}
        </TableCell>
        <TableCell
          id={`NGSRunCreationcreatedName_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.createdName}
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
